import React, { Component } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, Tooltip } from 'hljd'
import { observer, inject } from 'mobx-react'
import styles from '../style.module.less'
import { plusMinus, isTelSaleCityMerchant } from '@util'
import { getObjValue } from '@hlj/hlj-utils'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

@inject('store')
@observer
export default class extends Component {
  render() {
    const { overviewTab, changValue, overview } = this.props.store

    const timeArray = [['昨', '近7', '近30', '近60'], ['一', '7', '30', '60']]

    return (
      <div className={styles.block}>
        <p className={styles.title}>数据概览</p>

        <RadioGroup value={overviewTab} onChange={changValue('overviewTab')}>
          <RadioButton value="0">昨日</RadioButton>
          <RadioButton value="1">近7日</RadioButton>
          <RadioButton value="2">近30日</RadioButton>
          <RadioButton value="3">近60日</RadioButton>
        </RadioGroup>

        <div className={styles.box}>
          <div className={styles.label}>
            <p>
              {timeArray[0][overviewTab]}日环比<Tooltip
                placement="top"
                title={`指${timeArray[0][overviewTab]}日相比之前${
                  timeArray[1][overviewTab]
                }日的数值作比较，发生变化的百分比`}
              >
                <QuestionCircleOutlined />
              </Tooltip>
            </p>

            {!isTelSaleCityMerchant() && (
              <p>
                行业排名<Tooltip
                  placement="top"
                  title={
                    '在一定时间范围内的某个上述指标，在同城市同品类商家中的排名。注意：除了跳失率，其他指标越大越好'
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </p>
            )}
          </div>

          <div className={styles.data}>
            <ul>
              <li>
                曝光量<Tooltip
                  placement="top"
                  title={'在时间范围内，当前店铺总曝光次数'}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                访问量<Tooltip
                  placement="top"
                  title={'在时间范围内，当前店铺总访问(点击)次数'}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                CTR<Tooltip
                  placement="top"
                  title={'在时间范围内，当前店铺总访问(点击)次数 / 总曝光次数'}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                平均停留时长(s)<Tooltip
                  placement="top"
                  title={'在时间范围内，在店铺内平均停留时长'}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                跳失率<Tooltip
                  placement="top"
                  title={'在时间范围内，进店停留少于1s即离开的比例'}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
            </ul>

            <ul className={styles.num}>
              <li>{getObjValue(overview, 'expo_num.data') || 0}</li>
              <li>{getObjValue(overview, 'visit_num.data') || 0}</li>
              <li>{getObjValue(overview, 'ctr.data') || 0}</li>
              <li>{getObjValue(overview, 'duration.data') || 0}</li>
              <li>{getObjValue(overview, 'jumpout_rate.data') || 0}</li>
            </ul>

            <ul className={styles.compare}>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'expo_num.compare'))
                }}
              >
                {getObjValue(overview, 'expo_num.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'visit_num.compare'))
                }}
              >
                {getObjValue(overview, 'visit_num.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'ctr.compare'))
                }}
              >
                {getObjValue(overview, 'ctr.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'duration.compare'))
                }}
              >
                {getObjValue(overview, 'duration.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(
                    getObjValue(overview, 'jumpout_rate.compare')
                  )
                }}
              >
                {getObjValue(overview, 'jumpout_rate.compare') || 0}
              </li>
            </ul>
            <ul className={styles.ranking}>
              <li>{getObjValue(overview, 'expo_num.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'visit_num.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'ctr.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'duration.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'jumpout_rate.ranking') || '-'}</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
